import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { DailySalesRow, KpiSummaryRow } from '../models/salesperson-dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class SalespersonDashboardService {
  protected http = inject(HttpClient);
  protected baseUrl = 'json/salesperson-dashboard';

  getDailySales(salespersonCode?: string): Observable<DailySalesRow[]> {
    return this.http.get<DailySalesRow[]>(`${this.baseUrl}/dailySales`, {
      params: this.buildParams(salespersonCode)
    });
  }

  getSalesKpiSummary(salespersonCode?: string): Observable<KpiSummaryRow[]> {
    return this.http.get<KpiSummaryRow[]>(`${this.baseUrl}/salesKpiSummary`, {
      params: this.buildParams(salespersonCode)
    });
  }

  private buildParams(salespersonCode?: string): HttpParams {
    let params = new HttpParams();
    if (salespersonCode) {
      params = params.set('salespersonCode', salespersonCode);
    }
    return params;
  }
}
